import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../utils/helper';

const initialState = {
	popular: [],
	recomendation: [],
	loading: false,
};

export const handleGetRecomendation = createAsyncThunk(
  'search/handleGetRecomendation',
  async ({ latitude, longitude }) => {
    const url = `outlets/list-recommend?latitude=${latitude}&longitude=${longitude}`;
    const response = await axiosInstance.get(url);

    if (response?.data?.status === 'ok') {
      return response?.data?.result || [];
    }
    return [];
  }
);

export const handleGetPopularSearch = createAsyncThunk(
  'search/handleGetPopularSearch',
  async () => {
    const url = `product/suggest-keyword`;
    const response = await axiosInstance.get(url);

    if (response?.data?.status === 'ok') {
      return response?.data?.data || [];
    }
    return [];
  }
);

const search = createSlice({
	name: 'search',
	initialState,
	reducers: {
		setSearch: (state, action) => {
			return { ...state, ...action.payload };
		},
		clearSearch: () => {
			return initialState;  
		},
	},
  extraReducers: (builder) => {
    builder
    .addCase(handleGetRecomendation.pending, (state) => {
      state.loading = true;
    })
    .addCase(handleGetRecomendation.fulfilled, (state, action) => {
      state.loading = false;
      state.recomendation = action.payload;
    })
    .addCase(handleGetRecomendation.rejected, (state) => {
      state.loading = false;
    })
    .addCase(handleGetPopularSearch.pending, (state) => {
      state.loading = true;
    })
    .addCase(handleGetPopularSearch.fulfilled, (state, action) => {
      state.loading = false;
      state.popular = action.payload;
    });
  },
});

// Export actions and reducer
export const { setSearch, clearSearch } = search.actions;
export default search.reducer;